/**** mgt.Trip */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'Trip',
  title: 'Рейсы',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    marshvariants: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'MarshVariants',
      index: 'id',
      fields: ['route_short_name'],
      customsql: `SELECT ms.id, rt.route_short_name FROM mgt."MarshVariants" ms inner join mgt."Routes" rt ON rt.route_id=ms.route_id`,
      format: (elem: any) => elem['route_short_name'],
      autocomplete: true,
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'MarshVariant_id',
      title: 'Варианта маршрута',
      type: 'number',
      required: true,
      connection: 'marshvariants',
    },

    {
      name: 'race_type',
      title: 'Тип рейса',
      type: 'text',
      required: true,
    },
    {
      name: 'trajectory',
      title: 'Траектория',
      type: 'trajectory',
      required: true,
      disableFilter: true,
    },
    {
      title: 'Остановки на рейсе',
      type: 'composite',
      composite: {
        type: 'stopscoords',
        trip_id: 'trip_id',
        trajectory: 'trajectory'
      },
      disableSort: true,
    },
    {
      name: 'do_not_update',
      title: 'Отключить автообновление',
      type: 'boolean',
      required: false,
      width: '205px',
    },
  ],
  newTemplate: {
    id: null,
    MarshVariant_id: null,
    race_type: null,
    trajectory: null,
    do_not_update: true,
  },
  updateField: 'update_date',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'trip_id',
        field: 'id',
      },{
        title: 'route_variant_id',
        field: 'MarshVariant_id',
      },{
        title: 'trip_type',
        field: 'race_type',
      },
      {
        title: 'trajectory',
        field: 'trajectory',
      },
      {
        title: 'stops',
        field: '_____stops'
      }
    ],
    example: `1;1;A;"55.9687,37.149;55.9688,37.1500;55.9690,37.1502";"1,1009101;4,1009102"`,
  },
  export: {
    fields: [
      {
        name: 'MarshVariant_id',
        title: 'Вариант маршрута',
        connectionGetField: 'route_short_name',
      },
      {
        name: 'vehicle_type',
        title: 'Тип ТС',
        connection: 'vehicle_type',
        connectionKey: 'route_id',
        connectionGetField: 'route_type'
      },
      {
        name: 'race_type',
        title: 'Тип рейса'
      },
      {
        name: 'trajectory',
        title: 'Траектория',
        connection: 'trajectory_converted',
        connectionGetField: 'trajectory_converted',
        type: 'geometry'
        // format: {
        //   fields: ['dp_lat', 'dp_lon'],
        //   template: '%1;%2',
        // },
      },
    ],
    connections: {
      vehicle_type: {
        index: 'route_id',
        customsql:
          `
            SELECT
                v.route_type
            FROM
                mgt."Trip" t
            INNER JOIN
                mgt."MarshVariants" mv ON t."MarshVariant_id" = mv.id
            INNER JOIN
                mgt."Routes" r ON mv.route_id = r.route_id
            INNER JOIN
                mgt."Agency" ag ON r."Agency_id" = ag.agency_id
            INNER JOIN
                mgt."Depot" dp ON ag.agency_id = dp.agency_id
            INNER JOIN
                mgt."Vehicle" v ON dp.depot_id = v.depot_id
          `,
      },
      trajectory_converted: {
        index: 'id',
        customsql: `select ST_AsGeoJSON(trajectory) as trajectory_converted from mgt."Trip"`
      }
    }
  }
};

export default config;
